import _axios from '../../apiClient';

export function GetLocalidadesEntregaActivas() {
    return _axios
        .get(`/api/LocalidadEntrega/GetLocalidadesEntregaActivas`, {
            headers: { 'Content-Type': 'application/json;charset=UTF-8' }
        })
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            console.log('Error en la petición de localidades entrega activas', error);
            const data = error.response.data;
            throw data;
        });
}

// Obtener una localidad específica por ID
export function GetLocalidadEntrega(idLocalidadEntrega) {
    return _axios
        .get(`/api/LocalidadEntrega/GetLocalidadEntrega/${idLocalidadEntrega}`, {
            headers: { 'Content-Type': 'application/json;charset=UTF-8' }
        })
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            console.log('Error en la petición de localidad entrega por ID', error);
            const data = error.response.data;
            throw data;
        });
}